export const ImageStyle = {
  width: '72px',
  height: '72px',
  borderRadius: '50%',
  border: '3px solid white',
  cursor: 'pointer',
}
